<template>
  <div>
    <h1>Members</h1>
    <div v-if="loading">Loading...</div>
    <div v-else-if="error">Error: {{ error }}</div>
    <table v-else style="width:100%">
      <thead>
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Joined At</th>
          <th>Email</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in users" :key="user.id">
          <td>{{ user.ID }}</td>
          <td><a :href="`${baseURL}/profile?username=${user.name}`">
              {{ user.name }}
          </a></td>
          <td>{{ user.CreatedAt }}</td>
          <td>{{ user.email }}</td>
          <td>
            <button @click="deleteUser(user.name)" style="color: Red;">Delete</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import config from '../config';

export default {
  name: 'UserList',
  setup() {
    const users = ref([]);
    const loading = ref(true);
    const error = ref(null);

    const baseURL = window.location.origin;

    const fetchUsers = async () => {
      const token = sessionStorage.getItem("jwt");
      try {
        const response = await fetch(`${ config.apiBaseUrl }/admin/user/list`, {
          method: "GET",
          credentials: 'include',
          headers: {
            "Authorization": `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error('Failed to fetch invitation list');
        }
        const data = await response.json();
        users.value = data;
      } catch (err) {
        error.value = err.message;
      } finally {
        loading.value = false;
      }
    };

    const deleteUser = async (name) => {
      const token = sessionStorage.getItem("jwt");
      if (window.confirm("Are you sure you want to delete this member?")) {
        try {
          const response = await fetch(`${ config.apiBaseUrl }/admin/user/delete/${name}`, {
            method: 'DELETE',
            headers: {
              "Authorization": `Bearer ${token}`,
            }
          });
          if (!response.ok) {
            throw new Error('Failed to perform the action');
          }
          alert('User deleted successfully!');
          fetchUsers();
        } catch (err) {
          alert(`Error: ${err.message}`);
        }
      } else {
        console.log("Cancelled.");
      }
    };

    onMounted(fetchUsers);

    return {
      baseURL,
      deleteUser,
      users,
      loading,
      config,
      error
    };
  }
};
</script>

<style scoped>
/* Optional styling */
h1 {
  font-size: 2em;
  margin-bottom: 0.5em;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin-bottom: 1em;
  border-bottom: 1px solid #ccc;
  padding-bottom: 1em;
}
</style>
